import styled from '@emotion/styled';

import { BasicFlex } from '../Common';

import { Card, useTheme, Avatar } from '@mui/material';

import useIsMobile from '../../hooks/useIsMobile';

const StatCard = styled(Card)`
  width: fit-content;
  border-radius: 10px;
  background-color: ${props => props.$bg};
  color: ${props => props.$color};

  & * {
    color: ${props => props.$color};
  }
`;

const StatBox = styled(BasicFlex)`
  /* padding: 1rem 2rem; */
  width: fit-content;
`

const Stat = styled.div`
  font-size: 2rem;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`

const Title = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  opacity: .8;

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`

const StatBlock = ({Icon, stat, title, palette = "basic"}) => {
  const theme = useTheme();
  let bg = theme.palette[palette].light;
  let text = theme.palette[palette].dark;
  const { isMobile } = useIsMobile();

  return (
    <StatCard elevation={3} $color={text} $bg={bg} sx={{p: isMobile ? 1 : 2}}>
      <BasicFlex justify="center" gap={isMobile ? ".5rem" : "2rem"}>
        {Icon ? <Avatar variant="rounded" sx={{ bgcolor: bg, width: isMobile ? "3rem" : "4rem", height: isMobile ? "3rem" : "4rem" }}><Icon fontSize={isMobile ? "small" : "medium"}  /></Avatar> : null}
        <StatBox dir="column" align="center">
          <Stat>{stat}</Stat>
          <Title>{title}</Title>
        </StatBox>
      </BasicFlex>
    </StatCard>
  )
};

export default StatBlock;